import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { EventCard } from '@/components/common/EventCard';

import type { SanityEventType } from '@/types/sanity';
import type { Locale } from '@/types/shared';

interface EventGridProps {
  events: Partial<SanityEventType>[];
  locale: Locale;
  fallbackImage: any;
}

export const EventGrid = ({
  events,
  locale,
  fallbackImage,
}: EventGridProps) => {
  return (
    <StyledEventGrid>
      {events.map((event) => (
        <EventCard
          key={event._id}
          {...event}
          locale={locale}
          fallbackImage={fallbackImage}
        />
      ))}
    </StyledEventGrid>
  );
};

const StyledEventGrid = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-gap: var(--spacing-300);

  align-items: stretch;

  ${screen.sm} {
    grid-template-columns: 1fr 1fr;
  }

  ${screen.lg} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;
